/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Password_Requires_Unique_CharsInputs */

const nl_auth_password_errors_password_requires_unique_chars = /** @type {(inputs: Auth_Password_Errors_Password_Requires_Unique_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het wachtwoord moet meer unieke tekens bevatten`)
};

/**

* @param {Auth_Password_Errors_Password_Requires_Unique_CharsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_password_requires_unique_chars = /** @type {((inputs?: Auth_Password_Errors_Password_Requires_Unique_CharsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Password_Requires_Unique_CharsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_password_requires_unique_chars(inputs)
});
export { auth_password_errors_password_requires_unique_chars as "auth.password_errors.password_requires_unique_chars" }